import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "icon-check absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
};
const _hoisted_2 = {
  key: 0,
  class: "text-main-100 text-xs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-fit flex items-center gap-2 cursor-pointer select-none", [$props.variant, $props.size]])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["checkbox", ['relative aspect-square flex items-center gap-2 justify-center border-2 rounded-sm cursor-pointer shrink-0', {
      'active': this.modelValue
    }]])
  }, [this.modelValue ? (_openBlock(), _createElementBlock("i", _hoisted_1)) : _createCommentVNode("", true)], 2), this.text ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(this.text), 1)) : _createCommentVNode("", true)], 2);
}